import { render, staticRenderFns } from "./OCS.vue?vue&type=template&id=47eb2be2&scoped=true&"
import script from "./OCS.vue?vue&type=script&lang=js&"
export * from "./OCS.vue?vue&type=script&lang=js&"
import style0 from "./OCS.vue?vue&type=style&index=0&id=47eb2be2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb2be2",
  null
  
)

export default component.exports